window.$ = window.jQuery = require('jquery');
var marcadoErrores = require('./marcado-errores');
var Root = require('./root');
var modal = require('./modal');
var root = new Root();
import toastr from 'toastr';

(function () {
    var $cmd = $('meta[name="cmd"]');
    var $btnLoginAlta = $(".btn-login");
    if ($cmd.length > 0) {
        var cmd = $cmd.attr('content');
        if (cmd === "login") {
            $(".btn-login:first").trigger("click");
        } else if(cmd === "login-ok") {
            toastr.success('Sesión iniciada');
        }
    }

    $btnLoginAlta.on("click", function(e) {
        e.preventDefault();
        var enlace = $(this).attr("href");
        abrirLoginAlta(enlace);
    });

    function abrirLoginAlta(url) {
        $.ajax({
            url: url,
            type: "GET",
            cache: false,
            success: function(html) {
                modal.open({content: html});
                iniciarFormularios();
            },
            beforeSend: function() {
                $("#cargador").show();
            },
            complete: function() {
                $("#cargador").hide();
            }
        });
    }

    function iniciarFormularios() {
        var $menuAlta = $("#menu-alta");
        $menuAlta.on("submit", "form", function (e) {
            e.preventDefault();
            var $form = $(this);
            $.ajax({
                url: $form.attr("action"),
                type: "POST",
                data: $form.serialize(),
                cache: false,
                success: function(html) {
                    $("#menu-alta").html(html);
                    $("#cargador").show();
                    var reqCheckout = localStorage.getItem("requerir-checkout");
                    if (reqCheckout === "si") {
                        localStorage.removeItem("requerir-checkout");
                        window.location.replace(root.base + "/checkout/datos");
                    } else {
                        window.location.reload(false);
                    }
                },
                error: function (jqXHR) {
                    marcadoErrores(jqXHR, $form);
                },
                beforeSend: function() {
                    $("#cargador").show();
                },
                complete: function() {
                    $("#cargador").hide();
                }
            });
        });

        var $menuLogin = $("#menu-login");

        $menuLogin.on("submit", "form.login", function (e) {
            e.preventDefault();
            var $form = $(this);
            $.ajax({
                url: $form.attr("action"),
                type: "POST",
                data: $form.serialize(),
                cache: false,
                success: function() {
                    var reqCheckout = localStorage.getItem("requerir-checkout");
                    if (reqCheckout === "si") {
                        localStorage.removeItem("requerir-checkout");
                        window.location.replace(root.base + "/checkout/datos");
                    } else {
                        window.location.reload(false);
                    }
                },
                error: function (jqXHR) {
                    marcadoErrores(jqXHR, $form);
                },
                beforeSend: function() {
                    $("#cargador").show();
                },
                complete: function() {
                    $("#cargador").hide();
                }
            });
        });

        $menuLogin.on("click", ".btn-recuperar", function (e) {
            e.preventDefault();

            $.ajax({
                url: $(this).attr("href"),
                type: "GET",
                cache: false,
                success: function(html) {
                    $menuLogin.html(html);
                },
                beforeSend: function() {
                    $("#cargador").show();
                },
                complete: function() {
                    $("#cargador").hide();
                }
            });
        });

        $menuLogin.on("submit", "form.recuperacion", function (e) {
            e.preventDefault();
            var $form = $(this);
            $.ajax({
                url: $form.attr("action"),
                type: "POST",
                data: $form.serialize(),
                cache: false,
                success: function(html) {
                    $menuLogin.html(html);
                },
                error: function (jqXHR) {
                    marcadoErrores(jqXHR, $form);
                },
                beforeSend: function() {
                    $("#cargador").show();
                },
                complete: function() {
                    $("#cargador").hide();
                }
            });
        });

        $("#modal").on("cerrando", function () {
            $menuAlta.off();
            $menuLogin.off();
            $("#cargador").hide();
        });
    }
})();